import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { editComment, updateGameComment } from '~/api';
import { EditCommentRequest } from '~/types';
import { UpdateGameCommentRequest } from '~/types/missionGameApi';
import useToast from '~/store/useToast';
import useUpdateCommentList from './useUpdateCommentList';
import useUpdateGameCommentList from './useUpdateGameCommentList';

export const useEditCommentMutation = () => {
  const { showToast } = useToast();
  const { editCommentList } = useUpdateCommentList();

  return useMutation({
    mutationFn: (newComment: EditCommentRequest) => editComment(newComment),
    onSuccess: ({ status }, request) => {
      editCommentList(request);
    },
    onError: (error) => {
      showToast('error', 'delete failed');
    },
  });
};

export const useEditGameCommentMutation = () => {
  const { showToast } = useToast();
  const { editGameCommentList } = useUpdateGameCommentList();

  return useMutation({
    mutationFn: ({ newComment }: { newComment: UpdateGameCommentRequest }) =>
      updateGameComment(newComment),
    onSuccess: ({ status }, request) => {
      editGameCommentList({
        request: request.newComment,
        game_id: request.newComment.game_id,
      });
    },
    onError: (error) => {
      console.error(error);
      showToast('error', 'delete failed');
    },
  });
};
